import {
  equipmentFieldNameDictionary,
  FieldConfigurationLocationOptions,
  miscellaneousFieldNameDictionary,
  softwareFieldNameDictionary,
  studioServiceFieldNameDictionary,
} from '@models/FieldConfiguration.model';

export function getKeyByValue<V, T extends Record<string, V>>(
  object: T,
  value: V,
): keyof T | undefined {
  const keys = Object.keys(object) as (keyof T)[];
  return keys.find(key => object[key] === value);
}
export function findEquipmentField(
  location: FieldConfigurationLocationOptions,
  event: string,
) {
  if (location.includes('product'))
    return getKeyByValue(equipmentFieldNameDictionary, event);
  if (location.includes('software'))
    return getKeyByValue(softwareFieldNameDictionary, event);
  if (location.includes('miscellaneous'))
    return getKeyByValue(miscellaneousFieldNameDictionary, event);
  if (location.includes('studioService'))
    return getKeyByValue(studioServiceFieldNameDictionary, event);
  return undefined;
}
